<template>
<div>
    <v-layout row wrap justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
      <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
            <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Evaluación de atmósferas</h1>    
            <h2 class="animated bounceIn dura-2">Equipo de prueba de gases </h2>
      </v-flex> 
    <v-flex xs12 sm9 md7 mt-3 class="text-xs-left">  
        <span><strong>Continuemos con otra prueba  </strong></span>
        <p>Analiza la siguiente situación y completa los valores en la pantalla del medidor de gases.</p>  
        <p>Cuando se enciende el equipo se muestran las alarmas de alta (High alarm).
            <strong>Indicar los valores de la 2ª alarma establecidos por Ecopetrol para los siguientes contaminantes (% LEL, CO y H2S): </strong></p>
        <p class="instruccion">Digita el valor que corresponda en cada casilla. Presiona 'Enter' en cada casilla para validar tu respuesta. Una vez los valores digitados sean correctos puedes continuar con la siguiente pantalla.</p>
        <v-layout row wrap justify-center align-center text-xs-center pb-5 class="cont_page"> 
        </v-layout>
        <v-layout row wrap justify-center align-center text-xs-center pb-5 class="cont_page">
        <v-flex>
		<svg width="316.9" height="225.2" version="1.1" viewBox="0 0 316.9 225.2" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><metadata><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/><dc:title/></cc:Work></rdf:RDF></metadata>
            <g id="XMLID_2936_">
            <linearGradient id="XMLID_241_" x2="316.86" y1="112.58" y2="112.58" gradientUnits="userSpaceOnUse">
                <stop stop-color="#353535" offset="0"/>
                <stop stop-color="#4D494D" offset="1"/>
            </linearGradient>
            <rect id="XMLID_2945_" class="st810" width="316.9" height="225.2" fill="url(#XMLID_241_)"/>
            <path id="XMLID_2942_" class="st671" d="m300.6 215.6h-284.3c-1.4 0-2.5-1.1-2.5-2.5v-198.6c0-2.8 2.2-5 5-5h279.3c2.8 0 5 2.2 5 5v198.6c0 1.4-1.1 2.5-2.5 2.5z" fill="#605c60"/>
            <g id="XMLID_2937_">
                <linearGradient id="XMLID_243_" x1="149.42" x2="167.42" y1="16.185" y2="208.85" gradientUnits="userSpaceOnUse">
                <stop stop-color="#fff" offset="0"/>
                <stop stop-color="#DEFEF3" offset="1"/>
                </linearGradient>
                <path id="XMLID_2941_" class="st811" d="m285.1 203.2h-253.3c-2.8 0-5-2.2-5-5v-171.3c0-2.8 2.2-5 5-5h253.3c2.8 0 5 2.2 5 5v171.3c0 2.8-2.3 5-5 5z" fill="url(#XMLID_243_)"/>
                <path id="XMLID_2938_" class="st510" d="m285.1 204.7h-253.3c-3.6 0-6.5-2.9-6.5-6.5v-171.3c0-3.6 2.9-6.5 6.5-6.5h253.3c3.6 0 6.5 2.9 6.5 6.5v171.3c0 3.6-2.9 6.5-6.5 6.5zm-253.3-181.3c-1.9 0-3.5 1.6-3.5 3.5v171.3c0 1.9 1.6 3.5 3.5 3.5h253.3c1.9 0 3.5-1.6 3.5-3.5v-171.3c0-1.9-1.6-3.5-3.5-3.5z" fill="#515151"/>
            </g>
            </g><g fill="#444">
            <rect id="XMLID_2935_" class="st940" x="33.6" y="30.9" width="85.3" height="27.1"/>
            <rect id="XMLID_2934_" class="st940" x="123.3" y="30.9" width="85.3" height="27.1"/>
            <rect id="XMLID_2933_" class="st940" x="33.6" y="122.3" width="85.3" height="27.1"/>
            <rect id="XMLID_2932_" class="st940" x="33.6" y="183.1" width="247.2" height="16.2"/>
            <rect id="XMLID_2931_" class="st940" x="123.3" y="122.3" width="85.3" height="27.1"/>
            </g><g id="XMLID_2890_">
            <path id="XMLID_2898_" class="st940" d="m227.1 174c0 2.7 2.2 4.9 4.9 4.9h43.9c2.7 0 4.9-2.2 4.9-4.9v-20.1c0-2.7-2.2-4.9-4.9-4.9h-43.9c-2.7 0-4.9 2.2-4.9 4.9v4.2h-3.3v11.5h3.3zm4.9 1.7c-0.9 0-1.6-0.7-1.6-1.6v-20.1c0-0.9 0.7-1.6 1.6-1.6h43.9c0.9 0 1.6 0.7 1.6 1.6v20c0 0.9-0.7 1.6-1.6 1.6h-43.9z" fill="#444"/>
            <linearGradient id="XMLID_244_" x1="235.78" x2="275.57" y1="163.98" y2="163.98" gradientUnits="userSpaceOnUse">
                <stop stop-color="#54D354" offset="0"/>
                <stop stop-color="#119552" offset="1"/>
            </linearGradient>
            <polygon id="XMLID_2894_" class="st812" points="235.8 154.1 235.8 173.9 275.6 173.9 275.6 154.1" fill="url(#XMLID_244_)"/>
            </g>
            <g id="XMLID_2879_">
            <rect id="XMLID_1248_" class="st719" x="38.2" y="35.7" width="74" height="17.5" fill="none"/>
            <text class="st702 st636 st808" transform="translate(52.576 51.938)" fill="#ffffff" font-family="FontBase-Regular" font-size="23px">COMB</text>
            </g>
            <g id="XMLID_2838_">
            <rect id="XMLID_1269_" class="st719" x="38.2" y="127.1" width="74" height="17.5" fill="none"/>
            <text class="st702 st636 st808" transform="translate(83.442 143.39)" fill="#ffffff" font-family="FontBase-Regular" font-size="23px">CO</text>
            </g>
            <rect id="XMLID_2810_" class="st719" x="38.2" y="155.2" width="72" height="17.5" fill="none"/>
            <text id="XMLID_2808_" class="st940 st636 st808" transform="translate(38.191 171.46)" fill="#444444" font-family="FontBase-Regular" font-size="23px">9:46AM </text>
            <g id="XMLID_2699_">
            <rect id="XMLID_1250_" class="st719" x="128.7" y="35.7" width="74.2" height="17.5" fill="none"/>
            <text class="st702 st636 st808" transform="translate(175.56 51.938)" fill="#ffffff" font-family="FontBase-Regular" font-size="23px">O2</text>
            </g>
            <g id="espacio1"> 
            <linearGradient id="XMLID_245_" x1="33.496" x2="119.05" y1="73.923" y2="73.923" gradientUnits="userSpaceOnUse">
                <stop stop-color="#23CAD9" offset="0"/>
                <stop stop-color="#32ADF0" offset=".9898"/>
            </linearGradient>
            <rect id="XMLID_2405_" x="33.6" y="60.4" width="85.3" height="27.1" fill="#fff" stroke="url(#XMLID_245_)" stroke-miterlimit="10" stroke-width=".25"/>             
            <foreignObject class="item-drop" x="32.6" y="60.4" width="85.3" height="27.1">
				<input @keyup.enter="validando(texto[0],0)" 
                   :class="[{'errorR': error[0], 'bien':bien[0]}]" 
                   class="EntradaTxt " maxlength="3" type="text"
                   v-model="texto[0]"
            >
            </foreignObject>
            <rect id="XMLID_2698_" class="st719" x="56.4" y="61.7" width="55.7" height="24.4" fill="none"/>       
            </g>
            <rect id="XMLID_2679_" class="st719" x="143.4" y="61.7" width="59.5" height="24.4" fill="none"/>
            <text id="XMLID_2662_" class="st940 st636 st809" transform="translate(146.63 83.586)" fill="#444444" font-family="FontBase-Regular" font-size="28px">23.0</text>
            <g id="espacio2">
            <linearGradient id="XMLID_246_" x1="33.496" x2="119.05" y1="105.92" y2="105.92" gradientUnits="userSpaceOnUse">
                <stop stop-color="#23CAD9" offset="0"/>
                <stop stop-color="#32ADF0" offset=".9898"/>
            </linearGradient>             
                <rect id="XMLID_2433_" x="33.6" y="92.4" width="85.3" height="27.1" fill="#fff" stroke="url(#XMLID_246_)" stroke-miterlimit="10" stroke-width=".25"/>
                <foreignObject class="item-drop" x="32.6" y="92.4" width="85.3" height="27.1">
			<input @keyup.enter="validando(texto[1],1)" 
                   :class="[{'errorR': error[1], 'bien':bien[1]}]" 
                   class="EntradaTxt " maxlength="3" type="text" 
                   v-model="texto[1]"
            >
            </foreignObject>
            <rect id="XMLID_2656_" class="st719" x="55.1" y="93.7" width="57.1" height="24.4" fill="none"/>              
            </g>
            <g id="espacio3">
            <linearGradient id="XMLID_251_" x1="122.95" x2="208.5" y1="105.92" y2="105.92" gradientUnits="userSpaceOnUse">
                <stop stop-color="#23CAD9" offset="0"/>
                <stop stop-color="#32ADF0" offset=".9898"/>
            </linearGradient>             
                <rect id="XMLID_2449_" x="123.1" y="92.4" width="85.3" height="27.1" fill="#fff" stroke="url(#XMLID_251_)" stroke-miterlimit="10" stroke-width=".25"/>
                <foreignObject class="item-drop"  x="122.1" y="92.4" width="86.3" height="27.1">
			<input @keyup.enter="validando(texto[2],2)" 
                   :class="[{'errorR': error[2], 'bien':bien[2]}]" 
                   class="EntradaTxt " maxlength="3" type="text" 
                   v-model="texto[2]"
            >
            </foreignObject> 
            <rect id="XMLID_2635_" class="st719" x="150.8" y="93.7" width="52.1" height="24.4" fill="none"/>
            </g>
            <g id="XMLID_2429_">
            <rect id="XMLID_1225_" class="st719" x="128.7" y="127.1" width="74.2" height="17.5" fill="none"/>
            <text class="st702 st636 st808" transform="translate(163.28 143.39)" fill="#ffffff" font-family="FontBase-Regular" font-size="23px">H2S</text>
            </g>
            <g id="XMLID_2418_">
            <rect id="XMLID_1216_" class="st719" x="124.7" y="155.2" width="82.1" height="17.5" fill="none"/>
            <text class="st940 st636 st808" transform="translate(124.68 171.46)" fill="#444444" font-family="FontBase-Regular" font-size="23px"> AJUSTE</text>
            </g>
        </svg>
        <div class="">
            <v-layout row wrap justify-center align-center text-xs-center >  	
                <v-flex md12 class="text-xs-left opciones" >
				<span><strong>Estos son los posibles valores que pueden completar las casillas en blanco del medidor de gases. </strong></span><br>
			<table class="tabla mt-3"> 
      	<tbody>
        <tr class="fila1">
          <td align="center">1</td>
		  <td align="center">5</td>
		  <td align="center">10</td>
		  <td align="center">15</td>
		  <td align="center">20</td>
		  <td align="center">175</td>
		  <td align="center">75</td> 
        </tr>
      </tbody>
      </table>
				</v-flex> 
			</v-layout>
			<!--Retroalimentaciones-->   
			<v-layout justify-center >
			<v-flex xs12 sm9 md7 mt-1 class="retroalimentacion animated bounceIn" style="border: 2px solid #FF6C6C;" v-if="retroalim">
				<p v-if="retroalim" > <img class="icono" src="@/assets/imagenes_compartidas/14-icono-retroalimentacion-MAL.png" alt=""> Recuerda repasar los valores de las alarmas establecido por Ecopetrol visto en el tema anterior. Inténtalo nuevamente.</p>
			</v-flex>  
			</v-layout>   
			<v-layout justify-center >
			<v-flex xs12 sm9 md7 mt-1 class="retroalimentacion animated bounceIn" style="border: 2px solid #C7EE95;" v-if="excelente">
            <p v-if="excelente" > <img class="icono" src="@/assets/imagenes_compartidas/13-icono-retroalimentacion-BIEN.png" alt=""><strong> ¡Muy bien! Has ubicado correctamente los valores de alarma emitidas por el equipo.</strong></p>
			</v-flex> 
			</v-layout>    
        </div>
        </v-flex>
        </v-layout>
    </v-flex>
    </v-layout>
</div> 
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import draggable from 'vuedraggable'
import svg from "./svg/pantalla5-1";
export default {
components: {
    "svg1-app": svg,
    draggable
},
mixins: [nextConditions],
data() {
    return {
		vistos: Array(3).fill(false),
        textoCorrecto:[
			'20',
			'175',
			'15'
			],
		retroalim: false,
		excelente:false,
		verretro: false,
		bien:false,
		mal:false,
		texto:Array(3).fill(''),
		bien:Array(3).fill(false),
		error:Array(3).fill(false),
    }
},
methods: {
		
		checkAnswer() {
			this.retroalim = true;
			this.excelente = false;
		},
		reintentar() {	
			this.excelente = true
			this.retroalim = false;
		},
		validando(texto,idx){
		//console.log('Texto usuario: '+texto.toLowerCase())
		if(texto.toLowerCase()  === this.textoCorrecto[idx]){
		this.$set(this.bien, idx, true)
		var todosVistos = this.bien.every((el) => {
        return el;
		});
		if (todosVistos) {
			this.$store.commit("nextShow", true);
			
		}
		this.$set(this.error, idx, false)
		this.reintentar()
		}else{
		//console.log('Incorrecto')
		this.$set(this.bien, idx, false)
		this.$set(this.error, idx, true)  
		this.checkAnswer()
		} 
	},
},		
}
</script>
<style lang="scss" scoped>
@import '../../sass/globals';
.st0{fill:none;stroke:url(#XMLID_2661_);stroke-width:6;stroke-miterlimit:10;}
	.st1{fill:#46535B;}
	.st2{fill:url(#XMLID_4066_);stroke:#383838;stroke-miterlimit:10;}
	.st3{fill:#AAAAAA;}
	.st4{fill:url(#XMLID_7354_);stroke:#444444;stroke-miterlimit:10;}
	.st5{fill:url(#XMLID_7039_);}
	.st6{fill:url(#XMLID_7053_);}
	.st7{fill:url(#XMLID_7054_);}
	.st8{fill:url(#XMLID_7056_);}
	.st9{fill:url(#XMLID_7063_);}
	.st10{fill:url(#XMLID_7064_);}
	.st11{fill:url(#XMLID_7067_);}
	.st12{fill:url(#XMLID_7070_);}
	.st13{fill:url(#XMLID_7072_);}
	.st14{fill:url(#XMLID_7085_);}
	.st15{fill:url(#XMLID_7092_);}
	.st16{fill:url(#XMLID_7093_);}
	.st17{fill:url(#XMLID_7355_);stroke:#444444;stroke-miterlimit:10;}
	.st18{fill:url(#XMLID_7356_);stroke:#444444;stroke-miterlimit:10;}
	.st19{fill:#7C9DA5;}
	.st20{fill:#ABBFC6;}
	.st21{fill:url(#XMLID_7357_);stroke:#444444;stroke-miterlimit:10;}
	.st22{fill:url(#XMLID_7358_);stroke:#444444;stroke-miterlimit:10;}
	.st23{fill:url(#XMLID_7134_);}
	.st24{fill:url(#XMLID_7143_);}
	.st25{fill:#49493A;}
	.st26{fill:#AC7B63;}
	.st27{fill:url(#XMLID_7203_);}
	.st28{fill:url(#XMLID_7205_);}
	.st29{fill:url(#XMLID_7223_);}
	.st30{fill:url(#XMLID_7224_);}
	.st31{fill:url(#XMLID_7225_);}
	.st32{fill:url(#XMLID_7226_);}
	.st33{fill:url(#XMLID_7234_);}
	.st34{fill:url(#XMLID_7236_);}
	.st35{fill:url(#XMLID_7238_);}
	.st36{fill:url(#XMLID_7242_);}
	.st37{fill:url(#XMLID_7243_);}
	.st38{fill:url(#XMLID_7244_);}
	.st39{fill:url(#XMLID_7259_);}
	.st40{fill:url(#XMLID_7262_);}
	.st41{fill:url(#XMLID_7263_);}
	.st42{fill:url(#XMLID_7264_);}
	.st43{fill:url(#XMLID_7265_);}
	.st44{fill:url(#XMLID_7269_);}
	.st45{fill:url(#XMLID_7272_);}
	.st46{fill:url(#XMLID_7273_);}
	.st47{fill:url(#XMLID_7291_);}
	.st48{fill:url(#XMLID_7292_);}
	.st49{fill:url(#XMLID_7298_);}
	.st50{fill:#ADAC9C;}
	.st51{fill:#ADD86F;}
	.st52{fill:url(#XMLID_7301_);}
	.st53{fill:url(#XMLID_7302_);}
	.st54{fill:url(#XMLID_7304_);}
	.st55{fill:#105477;}
	.st56{fill:#106489;}
	.st57{fill:url(#XMLID_7320_);}
	.st58{fill:url(#XMLID_7322_);}
	.st59{fill:url(#XMLID_7328_);}
	.st60{fill:url(#XMLID_7329_);}
	.st61{fill:url(#XMLID_7332_);}
	.st62{fill:url(#XMLID_7339_);}
	.st63{fill:url(#XMLID_7340_);}
	.st64{fill:url(#XMLID_7341_);}
	.st65{fill:url(#XMLID_7347_);}
	.st66{fill:url(#XMLID_7352_);}
	.st67{fill:url(#XMLID_7353_);}
	.st68{fill:url(#XMLID_7359_);}
	.st69{fill:url(#XMLID_7360_);}
	.st70{fill:url(#XMLID_7361_);}
	.st71{fill:url(#XMLID_7367_);}
	.st72{fill:url(#XMLID_7369_);}
	.st73{fill:url(#XMLID_7370_);}
	.st74{fill:url(#XMLID_7373_);}
	.st75{fill:url(#XMLID_7375_);}
	.st76{fill:url(#XMLID_7379_);}
	.st77{fill:url(#XMLID_7380_);}
	.st78{fill:url(#XMLID_7381_);}
	.st79{fill:url(#XMLID_7382_);}
	.st80{fill:url(#XMLID_7383_);}
	.st81{fill:url(#XMLID_7384_);}
	.st82{fill:url(#XMLID_7390_);}
	.st83{fill:url(#XMLID_7391_);}
	.st84{fill:url(#XMLID_7394_);}
	.st85{fill:url(#XMLID_7395_);}
	.st86{fill:url(#XMLID_7396_);}
	.st87{fill:url(#XMLID_7397_);}
	.st88{fill:url(#XMLID_7398_);}
	.st89{fill:url(#XMLID_7399_);}
	.st90{fill:#AED379;}
	.st91{fill:none;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st92{fill:url(#XMLID_7400_);}
	.st93{fill:url(#XMLID_7401_);}
	.st94{fill:url(#XMLID_7403_);}
	.st95{fill:url(#XMLID_7405_);}
	.st96{fill:url(#XMLID_7406_);}
	.st97{fill:url(#XMLID_7407_);}
	.st98{fill:url(#XMLID_7410_);}
	.st99{fill:url(#XMLID_7411_);}
	.st100{fill:url(#XMLID_7412_);}
	.st101{fill:url(#XMLID_7413_);}
	.st102{fill:url(#XMLID_7414_);}
	.st103{fill:url(#XMLID_7415_);}
	.st104{fill:url(#XMLID_7416_);}
	.st105{fill:url(#XMLID_7417_);}
	.st106{fill:url(#XMLID_7418_);}
	.st107{fill:url(#XMLID_7421_);}
	.st108{fill:url(#XMLID_7422_);}
	.st109{fill:url(#XMLID_7427_);}
	.st110{fill:url(#XMLID_7428_);}
	.st111{fill:url(#XMLID_7429_);}
	.st112{fill:url(#XMLID_7430_);}
	.st113{fill:url(#XMLID_7431_);}
	.st114{fill:url(#XMLID_7432_);}
	.st115{fill:url(#XMLID_7433_);}
	.st116{fill:url(#XMLID_7434_);}
	.st117{fill:url(#XMLID_7435_);}
	.st118{fill:url(#XMLID_7436_);}
	.st119{fill:url(#XMLID_7437_);}
	.st120{fill:url(#XMLID_7438_);}
	.st121{fill:url(#XMLID_7439_);}
	.st122{fill:url(#XMLID_7440_);}
	.st123{fill:url(#XMLID_7441_);}
	.st124{fill:url(#XMLID_7442_);}
	.st125{fill:url(#XMLID_7443_);}
	.st126{fill:url(#XMLID_7444_);}
	.st127{fill:url(#XMLID_7445_);}
	.st128{fill:url(#XMLID_7450_);}
	.st129{fill:url(#XMLID_7452_);}
	.st130{fill:url(#XMLID_7453_);}
	.st131{fill:url(#XMLID_7454_);}
	.st132{fill:url(#XMLID_7455_);}
	.st133{fill:url(#XMLID_7456_);}
	.st134{fill:url(#XMLID_7459_);}
	.st135{fill:url(#XMLID_7460_);}
	.st136{fill:url(#XMLID_7463_);}
	.st137{fill:url(#XMLID_7466_);}
	.st138{fill:url(#XMLID_7468_);}
	.st139{fill:url(#XMLID_7469_);}
	.st140{fill:url(#XMLID_7470_);}
	.st141{fill:url(#XMLID_7471_);}
	.st142{fill:url(#XMLID_7472_);}
	.st143{fill:url(#XMLID_7473_);}
	.st144{fill:url(#XMLID_7474_);}
	.st145{fill:url(#XMLID_7475_);}
	.st146{fill:url(#XMLID_7477_);}
	.st147{fill:url(#XMLID_7478_);}
	.st148{fill:url(#XMLID_7479_);}
	.st149{fill:url(#XMLID_7480_);}
	.st150{fill:url(#XMLID_7481_);}
	.st151{fill:url(#XMLID_7482_);}
	.st152{fill:url(#XMLID_7483_);}
	.st153{fill:url(#XMLID_7484_);}
	.st154{fill:url(#XMLID_7486_);}
	.st155{fill:url(#XMLID_7488_);}
	.st156{fill:url(#XMLID_7489_);}
	.st157{fill:url(#XMLID_7490_);}
	.st158{fill:url(#XMLID_7491_);}
	.st159{fill:url(#XMLID_7492_);}
	.st160{fill:url(#XMLID_7493_);}
	.st161{fill:url(#XMLID_7494_);}
	.st162{fill:url(#XMLID_7495_);}
	.st163{fill:url(#XMLID_7496_);}
	.st164{fill:url(#XMLID_7497_);}
	.st165{fill:url(#XMLID_7498_);}
	.st166{fill:url(#XMLID_7499_);}
	.st167{fill:#E0B192;}
	.st168{fill:#E0CEBD;}
	.st169{fill:#E0D6D1;}
	.st170{fill:url(#XMLID_7500_);}
	.st171{fill:url(#XMLID_7501_);}
	.st172{fill:url(#XMLID_7502_);}
	.st173{fill:url(#XMLID_7503_);}
	.st174{fill:url(#XMLID_7504_);}
	.st175{fill:url(#XMLID_7506_);}
	.st176{fill:url(#XMLID_7507_);}
	.st177{fill:url(#XMLID_7508_);}
	.st178{fill:url(#XMLID_7509_);}
	.st179{fill:#E0E2DE;}
	.st180{fill:url(#XMLID_7510_);}
	.st181{fill:url(#XMLID_7512_);}
	.st182{fill:url(#XMLID_7513_);}
	.st183{fill:url(#XMLID_7517_);}
	.st184{fill:url(#XMLID_7518_);}
	.st185{fill:url(#XMLID_7519_);}
	.st186{fill:url(#XMLID_7520_);}
	.st187{fill:url(#XMLID_7522_);}
	.st188{fill:url(#XMLID_7523_);}
	.st189{fill:url(#XMLID_7524_);}
	.st190{fill:url(#XMLID_7525_);}
	.st191{fill:url(#XMLID_7526_);}
	.st192{fill:url(#XMLID_7527_);}
	.st193{fill:url(#XMLID_7528_);}
	.st194{fill:url(#XMLID_7529_);}
	.st195{fill:url(#XMLID_7530_);}
	.st196{fill:url(#XMLID_7531_);}
	.st197{fill:url(#XMLID_7532_);}
	.st198{fill:url(#XMLID_7533_);}
	.st199{fill:url(#XMLID_7536_);}
	.st200{fill:url(#XMLID_7537_);}
	.st201{fill:url(#XMLID_7540_);}
	.st202{fill:url(#XMLID_7541_);}
	.st203{fill:url(#XMLID_7542_);}
	.st204{fill:url(#XMLID_7543_);}
	.st205{fill:url(#XMLID_7544_);}
	.st206{fill:url(#XMLID_7547_);}
	.st207{fill:url(#XMLID_7548_);}
	.st208{fill:url(#XMLID_7551_);}
	.st209{fill:url(#XMLID_7552_);}
	.st210{fill:url(#XMLID_7553_);}
	.st211{fill:url(#XMLID_7554_);}
	.st212{fill:url(#XMLID_7555_);}
	.st213{fill:url(#XMLID_7556_);}
	.st214{fill:url(#XMLID_7557_);}
	.st215{fill:url(#XMLID_7560_);}
	.st216{fill:url(#XMLID_7562_);}
	.st217{fill:url(#XMLID_7563_);}
	.st218{fill:url(#XMLID_7564_);}
	.st219{fill:url(#XMLID_7566_);}
	.st220{fill:url(#XMLID_7567_);}
	.st221{fill:url(#XMLID_7569_);}
	.st222{fill:url(#XMLID_7570_);}
	.st223{fill:url(#XMLID_7571_);}
	.st224{fill:url(#XMLID_7572_);}
	.st225{fill:url(#XMLID_7573_);}
	.st226{fill:url(#XMLID_7574_);}
	.st227{fill:url(#XMLID_7575_);}
	.st228{fill:url(#XMLID_7576_);}
	.st229{fill:url(#XMLID_7577_);}
	.st230{fill:url(#XMLID_7578_);}
	.st231{fill:url(#XMLID_7579_);}
	.st232{fill:url(#XMLID_7580_);}
	.st233{fill:url(#XMLID_7581_);}
	.st234{fill:url(#XMLID_7582_);}
	.st235{fill:url(#XMLID_7583_);}
	.st236{fill:url(#XMLID_7584_);}
	.st237{fill:url(#XMLID_7585_);}
	.st238{fill:url(#XMLID_7586_);}
	.st239{fill:url(#XMLID_7587_);}
	.st240{fill:url(#XMLID_7594_);}
	.st241{fill:url(#XMLID_7595_);}
	.st242{fill:url(#XMLID_7596_);}
	.st243{fill:url(#XMLID_7597_);}
	.st244{fill:url(#XMLID_4070_);stroke:#383838;stroke-miterlimit:10;}
	.st245{fill:#132C33;}
	.st246{fill:url(#XMLID_7605_);}
	.st247{fill:url(#XMLID_7606_);}
	.st248{fill:url(#XMLID_7607_);}
	.st249{fill:url(#XMLID_7608_);}
	.st250{fill:#E1E1E1;}
	.st251{fill:url(#XMLID_7610_);}
	.st252{fill:url(#XMLID_7611_);}
	.st253{fill:url(#XMLID_7612_);}
	.st254{fill:url(#XMLID_7614_);}
	.st255{fill:url(#XMLID_7615_);}
	.st256{fill:url(#XMLID_7616_);}
	.st257{fill:url(#XMLID_7617_);}
	.st258{fill:url(#XMLID_7618_);}
	.st259{fill:url(#XMLID_7619_);}
	.st260{fill:url(#XMLID_7620_);}
	.st261{fill:url(#XMLID_7621_);}
	.st262{fill:url(#XMLID_7622_);}
	.st263{fill:url(#XMLID_7623_);}
	.st264{fill:url(#XMLID_7624_);}
	.st265{fill:url(#XMLID_7625_);}
	.st266{fill:url(#XMLID_7626_);}
	.st267{fill:url(#XMLID_7627_);}
	.st268{fill:url(#XMLID_7628_);}
	.st269{fill:url(#XMLID_7629_);}
	.st270{fill:url(#XMLID_7630_);}
	.st271{fill:url(#XMLID_7631_);}
	.st272{fill:url(#XMLID_7632_);}
	.st273{fill:url(#XMLID_7633_);}
	.st274{fill:url(#XMLID_7634_);}
	.st275{fill:url(#XMLID_7635_);}
	.st276{fill:url(#XMLID_7636_);}
	.st277{fill:url(#XMLID_7637_);}
	.st278{fill:url(#XMLID_7641_);}
	.st279{fill:url(#XMLID_7642_);}
	.st280{fill:url(#XMLID_7643_);}
	.st281{fill:url(#XMLID_7644_);}
	.st282{fill:url(#XMLID_7645_);}
	.st283{fill:url(#XMLID_7646_);}
	.st284{fill:url(#XMLID_7647_);}
	.st285{fill:url(#XMLID_7648_);}
	.st286{fill:url(#XMLID_7649_);}
	.st287{fill:url(#XMLID_7650_);}
	.st288{fill:url(#XMLID_7651_);}
	.st289{fill:url(#XMLID_7652_);}
	.st290{fill:url(#XMLID_7653_);}
	.st291{fill:url(#XMLID_7654_);}
	.st292{fill:url(#XMLID_7655_);}
	.st293{fill:url(#XMLID_7656_);}
	.st294{fill:url(#XMLID_7657_);}
	.st295{fill:url(#XMLID_7658_);}
	.st296{fill:url(#XMLID_7659_);}
	.st297{fill:url(#XMLID_7660_);}
	.st298{fill:url(#XMLID_7661_);}
	.st299{fill:url(#XMLID_7662_);}
	.st300{fill:url(#XMLID_7663_);}
	.st301{fill:url(#XMLID_7664_);}
	.st302{fill:url(#XMLID_7665_);}
	.st303{fill:url(#XMLID_7666_);}
	.st304{fill:url(#XMLID_7667_);}
	.st305{fill:url(#XMLID_7668_);}
	.st306{fill:url(#XMLID_7669_);}
	.st307{fill:url(#XMLID_7670_);}
	.st308{fill:url(#XMLID_7671_);}
	.st309{fill:url(#XMLID_7672_);}
	.st310{fill:url(#XMLID_7674_);}
	.st311{fill:url(#XMLID_7675_);}
	.st312{fill:url(#XMLID_7676_);}
	.st313{fill:url(#XMLID_7679_);}
	.st314{fill:url(#XMLID_7682_);}
	.st315{fill:url(#XMLID_7683_);}
	.st316{fill:url(#XMLID_7684_);}
	.st317{fill:url(#XMLID_7686_);}
	.st318{fill:url(#XMLID_7689_);}
	.st319{fill:url(#XMLID_7690_);}
	.st320{fill:url(#XMLID_7691_);}
	.st321{fill:url(#XMLID_7692_);}
	.st322{fill:url(#XMLID_7693_);}
	.st323{fill:url(#XMLID_7696_);}
	.st324{fill:url(#XMLID_7697_);}
	.st325{fill:#E24471;}
	.st326{fill:#144191;}
	.st327{fill:url(#XMLID_7700_);}
	.st328{fill:url(#XMLID_7703_);}
	.st329{fill:url(#XMLID_7704_);}
	.st330{fill:url(#XMLID_7705_);}
	.st331{fill:url(#XMLID_7706_);}
	.st332{fill:url(#XMLID_7708_);}
	.st333{fill:url(#XMLID_7709_);}
	.st334{fill:#E2E2E2;}
	.st335{fill:url(#XMLID_7710_);}
	.st336{fill:url(#XMLID_7711_);}
	.st337{fill:url(#XMLID_7712_);}
	.st338{fill:url(#XMLID_7713_);}
	.st339{fill:url(#XMLID_7714_);}
	.st340{fill:url(#XMLID_7717_);}
	.st341{fill:url(#XMLID_7718_);}
	.st342{fill:url(#XMLID_7721_);}
	.st343{fill:none;stroke:#FF7676;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}
	.st344{fill:none;stroke:url(#XMLID_2675_);stroke-width:6;stroke-miterlimit:10;}
	.st345{clip-path:url(#XMLID_245_);}
	.st346{fill:none;stroke:url(#XMLID_2676_);stroke-width:6;stroke-miterlimit:10;}
	.st347{fill:url(#XMLID_7362_);stroke:#444444;stroke-miterlimit:10;}
	.st348{fill:url(#XMLID_7363_);stroke:#444444;stroke-miterlimit:10;}
	.st349{fill:url(#XMLID_7364_);stroke:#444444;stroke-miterlimit:10;}
	.st350{clip-path:url(#XMLID_392_);}
	.st351{fill:none;stroke:url(#XMLID_7206_);stroke-width:3;stroke-miterlimit:10;}
	.st352{fill:none;stroke:url(#XMLID_7348_);stroke-width:2;stroke-miterlimit:10;}
	.st353{fill:none;stroke:#042AB2;stroke-width:5;stroke-miterlimit:10;}
	.st354{fill:url(#XMLID_7365_);stroke:#444444;stroke-miterlimit:10;}
	.st355{fill:none;stroke:url(#XMLID_7677_);stroke-width:5;stroke-miterlimit:10;}
	.st356{fill:none;stroke:url(#XMLID_7349_);stroke-width:2;stroke-miterlimit:10;}
	.st357{fill:none;stroke:url(#XMLID_7376_);stroke-width:3;stroke-miterlimit:10;}
	.st358{fill:url(#XMLID_7366_);stroke:#444444;stroke-miterlimit:10;}
	.st359{fill:url(#XMLID_4110_);stroke:#383838;stroke-miterlimit:10;}
	.st360{fill:none;stroke:url(#XMLID_3331_);stroke-width:6;stroke-miterlimit:10;}
	.st361{fill:none;stroke:url(#XMLID_7377_);stroke-width:3;stroke-miterlimit:10;}
	.st362{fill:none;stroke:url(#XMLID_7209_);stroke-width:3;stroke-miterlimit:10;}
	.st363{fill:none;stroke:#1D1D1B;stroke-width:0.5;stroke-miterlimit:10;}
	.st364{fill:none;stroke:url(#XMLID_7378_);stroke-width:3;stroke-miterlimit:10;}
	.st365{fill:#4A7B8E;}
	.st366{fill:#E50A0A;}
	.st367{fill:#E51B72;}
	.st368{fill:none;stroke:#1D1D1B;stroke-miterlimit:10;}
	.st369{fill:#FFFFFF;stroke:url(#XMLID_7281_);stroke-width:0.25;stroke-miterlimit:10;}
	.st370{fill:#E5E1DC;}
	.st371{fill:none;stroke:url(#XMLID_3336_);stroke-width:6;stroke-miterlimit:10;}
	.st372{fill:none;stroke:url(#XMLID_2300_);stroke-width:6;stroke-miterlimit:10;}
	.st373{fill:url(#XMLID_4004_);}
	.st374{fill:url(#XMLID_4048_);}
	.st375{fill:url(#XMLID_4049_);}
	.st376{fill:url(#XMLID_4052_);}
	.st377{fill:url(#XMLID_4053_);}
	.st378{fill:url(#XMLID_4054_);}
	.st379{fill:url(#XMLID_4058_);}
	.st380{fill:url(#XMLID_4065_);}
	.st381{fill:url(#XMLID_4072_);}
	.st382{fill:url(#XMLID_4075_);}
	.st383{fill:#FFFFFF;stroke:url(#XMLID_7702_);stroke-width:3;stroke-miterlimit:10;}
	.st384{fill:url(#XMLID_4098_);}
	.st385{fill:url(#XMLID_4099_);}
	.st386{fill:#FFFFFF;stroke:url(#XMLID_7275_);stroke-width:0.25;stroke-miterlimit:10;}
	.st387{fill:url(#XMLID_7457_);stroke:#383838;stroke-miterlimit:10;}
	.st388{fill:url(#XMLID_4100_);}
	.st389{fill:url(#XMLID_4102_);}
	.st390{fill:url(#XMLID_4103_);}
	.st391{fill:#191A1C;}
	.st392{fill:none;stroke:#F9385D;stroke-width:3;stroke-miterlimit:10;}
	.st393{opacity:0.39;fill:#042AB2;}
	.st394{fill:#FFFFFF;stroke:url(#XMLID_7707_);stroke-width:3;stroke-miterlimit:10;}
	.st395{fill:#4D8E02;}
	.st396{fill:none;stroke:url(#XMLID_7144_);stroke-width:2;stroke-miterlimit:10;}
	.st397{fill:#E866FF;}
	.st398{fill:#E8B897;}
	.st399{fill:#E8E8DA;}
	.st400{fill:#E8E8E8;}
	.st401{fill:url(#XMLID_7069_);stroke:#232323;stroke-miterlimit:10;}
	.st402{fill:none;stroke:url(#XMLID_7449_);stroke-width:4;stroke-miterlimit:10;}
	.st403{fill:#FFFFFF;stroke:url(#XMLID_7285_);stroke-width:0.25;stroke-miterlimit:10;}
	.st404{fill:none;stroke:url(#XMLID_4782_);stroke-width:6;stroke-miterlimit:10;}
	.st405{fill:none;stroke:url(#XMLID_2680_);stroke-width:6;stroke-miterlimit:10;}
	.st406{fill:#4F4D4F;}
	.st407{fill:#4F514C;}
	.st408{clip-path:url(#XMLID_3412_);}
	.st409{fill:none;stroke:url(#XMLID_7350_);stroke-width:2;stroke-miterlimit:10;}
	.st410{fill:#FFFFFF;stroke:url(#XMLID_7279_);stroke-width:0.25;stroke-miterlimit:10;}
	.st411{fill:none;stroke:#96BCB5;stroke-miterlimit:10;}
	.st412{fill:none;stroke:url(#XMLID_7351_);stroke-width:2;stroke-miterlimit:10;}
	.st413{fill:none;stroke:url(#XMLID_7448_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st414{fill:#FFFFFF;stroke:url(#XMLID_7313_);stroke-width:0.25;stroke-miterlimit:10;}
	.st415{fill:#B0CAD1;}
	.st416{fill:#B0D882;}
	.st417{fill:#FFFFFF;stroke:url(#XMLID_7295_);stroke-width:0.25;stroke-miterlimit:10;}
	.st418{fill:url(#XMLID_7371_);stroke:#444444;stroke-miterlimit:10;}
	.st419{fill:#B0FFFF;}
	.st420{fill:url(#XMLID_7372_);stroke:#444444;stroke-miterlimit:10;}
	.st421{fill:none;stroke:url(#XMLID_4074_);stroke-width:4;stroke-miterlimit:10;}
	.st422{clip-path:url(#XMLID_3604_);}
	.st423{clip-path:url(#XMLID_3611_);}
	.st424{fill:url(#XMLID_4601_);}
	.st425{fill:url(#XMLID_4602_);}
	.st426{fill:url(#XMLID_4606_);}
	.st427{fill:url(#XMLID_4607_);}
	.st428{fill:url(#XMLID_4608_);}
	.st429{fill:url(#XMLID_4609_);}
	.st430{fill:url(#XMLID_4610_);}
	.st431{fill:url(#XMLID_4611_);}
	.st432{fill:url(#XMLID_4614_);}
	.st433{fill:url(#XMLID_4617_);}
	.st434{fill:url(#XMLID_4620_);}
	.st435{fill:url(#XMLID_4630_);}
	.st436{fill:url(#XMLID_4632_);}
	.st437{fill:url(#XMLID_4633_);}
	.st438{fill:url(#XMLID_4648_);}
	.st439{fill:url(#XMLID_4689_);}
	.st440{fill:#FFFFFF;stroke:url(#XMLID_7307_);stroke-width:0.25;stroke-miterlimit:10;}
	.st441{fill:#FFFFFF;stroke:url(#XMLID_7289_);stroke-width:0.25;stroke-miterlimit:10;}
	.st442{fill:none;stroke:#E2E2E2;stroke-miterlimit:10;}
	.st443{fill:#FFFFFF;stroke:url(#XMLID_7678_);stroke-width:3;stroke-miterlimit:10;}
	.st444{fill:url(#XMLID_4732_);}
	.st445{fill:url(#XMLID_4734_);}
	.st446{fill:url(#XMLID_4737_);}
	.st447{fill:url(#XMLID_4738_);}
	.st448{fill:url(#XMLID_4739_);}
	.st449{fill:url(#XMLID_4740_);}
	.st450{fill:url(#XMLID_4742_);}
	.st451{fill:url(#XMLID_4745_);}
	.st452{fill:url(#XMLID_4751_);}
	.st453{fill:url(#XMLID_4773_);}
	.st454{fill:url(#XMLID_4774_);}
	.st455{fill:url(#XMLID_4775_);}
	.st456{fill:#FFFFFF;stroke:url(#XMLID_7323_);stroke-width:0.25;stroke-miterlimit:10;}
	.st457{fill:url(#XMLID_4780_);}
	.st458{fill:url(#XMLID_4781_);}
	.st459{fill:url(#XMLID_4792_);}
	.st460{fill:url(#XMLID_4793_);}
	.st461{fill:#83FFE7;}
	.st462{fill:#FFFFFF;stroke:#444444;stroke-miterlimit:10;}
	.st463{fill:url(#XMLID_7461_);stroke:#383838;stroke-miterlimit:10;}
	.st464{fill:url(#XMLID_7462_);stroke:#383838;stroke-miterlimit:10;}
	.st465{fill:#848484;}
	.st466{fill:none;stroke:url(#XMLID_3605_);stroke-width:2;stroke-miterlimit:10;}
	.st467{fill:none;stroke:url(#XMLID_2292_);stroke-width:2;stroke-miterlimit:10;}
	.st468{fill:url(#XMLID_4809_);}
	.st469{fill:none;stroke:url(#XMLID_2310_);stroke-width:6;stroke-miterlimit:10;}
	.st470{fill:url(#XMLID_4816_);}
	.st471{fill:url(#XMLID_4817_);}
	.st472{fill:url(#XMLID_4818_);}
	.st473{fill:url(#XMLID_4819_);}
	.st474{fill:none;stroke:url(#XMLID_7589_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st475{fill:#FFFFFF;stroke:url(#XMLID_7317_);stroke-width:0.25;stroke-miterlimit:10;}
	.st476{fill:#B4754D;}
	.st477{fill:#B4B4B4;}
	.st478{fill:none;stroke:url(#XMLID_2314_);stroke-width:6;stroke-miterlimit:10;}
	.st479{fill:url(#XMLID_4923_);}
	.st480{fill:url(#XMLID_4925_);}
	.st481{fill:url(#XMLID_4950_);}
	.st482{fill:url(#XMLID_4951_);}
	.st483{fill:url(#XMLID_4952_);}
	.st484{fill:url(#XMLID_4953_);}
	.st485{fill:url(#XMLID_4954_);}
	.st486{fill:url(#XMLID_4955_);}
	.st487{fill:url(#XMLID_4956_);}
	.st488{fill:url(#XMLID_4957_);}
	.st489{fill:url(#XMLID_4958_);}
	.st490{fill:url(#XMLID_4959_);}
	.st491{fill:none;stroke:url(#XMLID_2297_);stroke-width:2;stroke-miterlimit:10;}
	.st492{fill:#FFFFFF;stroke:url(#XMLID_7715_);stroke-width:3;stroke-miterlimit:10;}
	.st493{fill:none;stroke:#1E1E1E;stroke-miterlimit:10;}
	.st494{fill:#B5AC9C;}
	.st495{fill:#B5B5B5;}
	.st496{fill:none;stroke:url(#XMLID_7598_);stroke-width:3;stroke-miterlimit:10;}
	.st497{fill:url(#XMLID_7695_);stroke:#232323;stroke-miterlimit:10;}
	.st498{fill:#EAEAEA;}
	.st499{fill:#B7B7B7;}
	.st500{fill:#1D1D1B;}
	.st501{fill:none;stroke:url(#XMLID_2365_);stroke-width:3;stroke-miterlimit:10;}
	.st502{fill:#898989;}
	.st503{fill:#1E1E1E;}
	.st504{fill:#FFFFFF;stroke:url(#XMLID_7681_);stroke-width:3;stroke-miterlimit:10;}
	.st505{fill:#EDEDED;}
	.st506{fill:#505154;}
	.st507{fill:#FFFFFF;stroke:url(#XMLID_7685_);stroke-width:3;stroke-miterlimit:10;}
	.st508{fill:#FFFFFF;stroke:url(#XMLID_7687_);stroke-width:3;stroke-miterlimit:10;}
	.st509{fill:#513B1E;}
	.st510{fill:#515151;}
	.st511{fill:none;stroke:url(#XMLID_7402_);stroke-width:2;stroke-miterlimit:10;}
	.st512{fill:#EF5A24;}
	.st513{fill:none;stroke:url(#XMLID_256_);stroke-width:2;stroke-miterlimit:10;}
	.st514{fill:#FFFFFF;stroke:url(#XMLID_7720_);stroke-width:3;stroke-miterlimit:10;}
	.st515{fill:#EFEFEF;}
	.st516{fill:none;stroke:url(#XMLID_2325_);stroke-width:6;stroke-miterlimit:10;}
	.st517{fill:none;stroke:url(#XMLID_7464_);stroke-width:4;stroke-miterlimit:10;}
	.st518{fill:none;stroke:url(#XMLID_7465_);stroke-width:4;stroke-miterlimit:10;}
	.st519{fill:none;stroke:url(#XMLID_4778_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st520{fill:#544733;}
	.st521{fill:#545454;}
	.st522{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}
	.st523{fill:none;stroke:url(#XMLID_7467_);stroke-width:4;stroke-miterlimit:10;}
	.st524{fill:url(#XMLID_7068_);stroke:#383838;stroke-miterlimit:10;}
	.st525{fill:#555555;}
	.st526{fill:none;stroke:url(#XMLID_7200_);stroke-width:2;stroke-miterlimit:10;}
	.st527{fill:#56361A;}
	.st528{fill:#564A3D;}
	.st529{fill:#BAC8D1;}
	.st530{fill:#BB8062;}
	.st531{fill:none;stroke:#28F7D1;stroke-width:3;stroke-miterlimit:10;}
	.st532{fill:none;stroke:url(#XMLID_7590_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st533{fill:none;stroke:url(#XMLID_2299_);stroke-width:6;stroke-miterlimit:10;}
	.st534{clip-path:url(#XMLID_7202_);}
	.st535{clip-path:url(#XMLID_7208_);}
	.st536{clip-path:url(#XMLID_7222_);}
	.st537{fill:none;stroke:url(#XMLID_7600_);stroke-width:6;stroke-miterlimit:10;}
	.st538{fill:none;stroke:url(#XMLID_7601_);stroke-width:6;stroke-miterlimit:10;}
	.st539{fill:none;stroke:url(#XMLID_7602_);stroke-width:6;stroke-miterlimit:10;}
	.st540{fill:#8E734F;}
	.st541{fill:none;stroke:url(#XMLID_7603_);stroke-width:6;stroke-miterlimit:10;}
	.st542{fill:none;stroke:#F9385D;stroke-width:2;stroke-miterlimit:10;}
	.st543{clip-path:url(#XMLID_7368_);}
	.st544{fill:#C7EE95;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st545{fill:none;stroke:url(#XMLID_2335_);stroke-width:6;stroke-miterlimit:10;}
	.st546{fill:#8F9D9E;}
	.st547{fill:url(#XMLID_7073_);stroke:#383838;stroke-miterlimit:10;}
	.st548{clip-path:url(#XMLID_7404_);}
	.st549{clip-path:url(#XMLID_7420_);}
	.st550{fill:url(#XMLID_7074_);stroke:#383838;stroke-miterlimit:10;}
	.st551{clip-path:url(#XMLID_7451_);}
	.st552{fill:none;stroke:url(#XMLID_7476_);stroke-width:4;stroke-miterlimit:10;}
	.st553{fill:none;stroke:url(#XMLID_7609_);stroke-width:6;stroke-miterlimit:10;}
	.st554{fill:#BFBFBF;}
	.st555{clip-path:url(#XMLID_7515_);}
	.st556{clip-path:url(#XMLID_7521_);}
	.st557{clip-path:url(#XMLID_7539_);}
	.st558{clip-path:url(#XMLID_7593_);}
	.st559{fill:url(#XMLID_7546_);stroke:#232323;stroke-miterlimit:10;}
	.st560{fill:url(#XMLID_7694_);stroke:#383838;stroke-miterlimit:10;}
	.st561{opacity:0.58;fill:#FFFFFF;}
	.st562{clip-path:url(#XMLID_7604_);}
	.st563{fill:none;stroke:url(#XMLID_7511_);stroke-width:4;stroke-miterlimit:10;}
	.st564{fill:#2368D9;}
	.st565{clip-path:url(#XMLID_7688_);}
	.st566{fill:#23CAD9;}
	.st567{fill:url(#XMLID_7698_);stroke:#383838;stroke-miterlimit:10;}
	.st568{fill:none;stroke:url(#XMLID_7514_);stroke-width:4;stroke-miterlimit:10;}
	.st569{fill:url(#XMLID_7699_);stroke:#383838;stroke-miterlimit:10;}
	.st570{clip-path:url(#XMLID_7716_);}
	.st571{fill:#F2F2F2;}
	.st572{fill:none;stroke:url(#XMLID_4073_);stroke-width:3;stroke-miterlimit:10;}
	.st573{fill:none;stroke:url(#XMLID_3612_);stroke-width:6;stroke-miterlimit:10;}
	.st574{fill:#F3F3E5;}
	.st575{fill:#FFFFFF;stroke:url(#XMLID_7278_);stroke-width:0.25;stroke-miterlimit:10;}
	.st576{fill:none;stroke:url(#XMLID_7446_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st577{fill:#FFFFFF;stroke:url(#XMLID_7535_);stroke-width:3;stroke-miterlimit:10;}
	.st578{fill:#F4C4A4;}
	.st579{fill:#FFFFFF;stroke:url(#XMLID_7538_);stroke-width:3;stroke-miterlimit:10;}
	.st580{fill:#FFFFFF;stroke:url(#XMLID_7294_);stroke-width:0.25;stroke-miterlimit:10;}
	.st581{opacity:0.4;fill:#1D1D1B;}
	.st582{fill:#FFFFFF;stroke:url(#XMLID_7288_);stroke-width:0.25;stroke-miterlimit:10;}
	.st583{clip-path:url(#XMLID_4005_);}
	.st584{fill:url(#XMLID_4603_);stroke:#383838;stroke-miterlimit:10;}
	.st585{fill:#282828;}
	.st586{clip-path:url(#XMLID_4096_);}
	.st587{fill:none;stroke:url(#XMLID_7613_);stroke-width:6;stroke-miterlimit:10;}
	.st588{fill:url(#XMLID_4604_);stroke:#383838;stroke-miterlimit:10;}
	.st589{fill:#28F7D1;}
	.st590{fill:#F7B033;}
	.st591{fill:#F7F7F7;}
	.st592{fill:#F7F8F9;}
	.st593{fill:none;stroke:url(#XMLID_7485_);stroke-width:4;stroke-miterlimit:10;}
	.st594{fill:none;stroke:url(#XMLID_3829_);stroke-width:6;stroke-miterlimit:10;}
	.st595{fill:none;stroke:url(#XMLID_3414_);stroke-width:6;stroke-miterlimit:10;}
	.st596{fill:none;stroke:url(#XMLID_7487_);stroke-width:4;stroke-miterlimit:10;}
	.st597{fill:#FFFFFF;stroke:url(#XMLID_7316_);stroke-width:0.25;stroke-miterlimit:10;}
	.st598{fill:none;stroke:url(#XMLID_7186_);stroke-width:2;stroke-miterlimit:10;}
	.st599{fill:#5E5E5E;}
	.st600{fill:#F9385D;}
	.st601{fill:none;stroke:url(#XMLID_7638_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st602{opacity:0.35;fill:#9FEDFF;}
	.st603{fill:#FFFFFF;stroke:url(#XMLID_7326_);stroke-width:0.25;stroke-miterlimit:10;}
	.st604{fill:#C07E61;}
	.st605{fill:#918E91;}
	.st606{fill:#C0C1BB;}
	.st607{fill:#C12F52;}
	.st608{fill:#929292;}
	.st609{fill:#C1A880;}
	.st610{fill:#C1C1C1;}
	.st611{fill:none;stroke:url(#XMLID_7701_);stroke-width:3;stroke-miterlimit:10;}
	.st612{fill:url(#SVGID_1_);}
	.st613{fill:#93837A;}
	.st614{fill:#9397A5;}
	.st615{fill:#939FA3;}
	.st616{fill:#93ADAD;}
	.st617{fill:#943B8A;}
	.st618{fill:#C3CDDD;}
	.st619{fill:#C7EE95;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}
	.st620{fill:url(#XMLID_5862_);}
	.st621{fill:url(#XMLID_5863_);}
	.st622{fill:url(#XMLID_5925_);}
	.st623{fill:url(#XMLID_5926_);}
	.st624{fill:url(#XMLID_5927_);}
	.st625{fill:url(#XMLID_5931_);}
	.st626{fill:url(#XMLID_5933_);}
	.st627{fill:url(#XMLID_5934_);}
	.st628{fill:url(#XMLID_5935_);}
	.st629{fill:url(#XMLID_5936_);}
	.st630{fill:url(#XMLID_5943_);}
	.st631{fill:#95BAC6;}
	.st632{fill:#C54EB9;}
	.st633{fill:none;stroke:url(#XMLID_7195_);stroke-width:2;stroke-miterlimit:10;}
	.st634{fill:#2B2B2B;}
	.st635{fill:none;stroke:url(#XMLID_7196_);stroke-width:2;stroke-miterlimit:10;}
	.st636{font-family:'FontBase-Regular';}
	.st637{fill:none;stroke:url(#XMLID_7199_);stroke-width:2;stroke-miterlimit:10;}
	.st638{fill:url(#XMLID_7545_);stroke:#383838;stroke-miterlimit:10;}
	.st639{fill:none;stroke:url(#XMLID_4776_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st640{fill:#FFFFFF;stroke:#B7B7B7;stroke-width:0.75;stroke-miterlimit:10;}
	.st641{fill:#C7EE95;}
	.st642{fill:#C7F2E9;}
	.st643{fill:#2D2D2D;}
	.st644{fill:#FBE429;}
	.st645{fill:url(#XMLID_7549_);stroke:#383838;stroke-miterlimit:10;}
	.st646{fill:none;stroke:url(#XMLID_7534_);stroke-width:4;stroke-miterlimit:10;}
	.st647{fill:none;stroke:#042AB2;stroke-width:3;stroke-miterlimit:10;}
	.st648{fill:#998365;}
	.st649{fill:#99845F;}
	.st650{fill:url(#XMLID_2290_);}
	.st651{fill:url(#XMLID_2291_);}
	.st652{fill:url(#XMLID_2294_);}
	.st653{fill:url(#XMLID_2295_);}
	.st654{fill:url(#XMLID_2296_);}
	.st655{fill:url(#XMLID_2298_);}
	.st656{fill:none;stroke:#28F7D1;stroke-width:2;stroke-miterlimit:10;}
	.st657{fill:url(#XMLID_2307_);}
	.st658{fill:url(#XMLID_2308_);}
	.st659{fill:url(#XMLID_2309_);}
	.st660{fill:url(#XMLID_2311_);}
	.st661{fill:url(#XMLID_2312_);}
	.st662{fill:url(#XMLID_2319_);}
	.st663{fill:url(#XMLID_2322_);}
	.st664{fill:url(#XMLID_2334_);}
	.st665{fill:url(#XMLID_2356_);}
	.st666{fill:#C9C9C9;}
	.st667{fill:url(#XMLID_2391_);}
	.st668{fill:url(#XMLID_2392_);}
	.st669{fill:url(#XMLID_2399_);}
	.st670{fill:#605147;}
	.st671{fill:#605C60;}
	.st672{fill:url(#XMLID_2400_);}
	.st673{fill:url(#XMLID_2426_);}
	.st674{fill:url(#XMLID_2427_);}
	.st675{fill:url(#XMLID_2430_);}
	.st676{fill:url(#XMLID_2432_);}
	.st677{fill:url(#XMLID_2484_);}
	.st678{fill:#FFFFFF;stroke:url(#XMLID_7559_);stroke-width:3;stroke-miterlimit:10;}
	.st679{fill:none;stroke:url(#XMLID_7599_);stroke-width:6;stroke-miterlimit:10;}
	.st680{fill:#FF3BCC;}
	.st681{fill:url(#XMLID_2510_);}
	.st682{fill:#FF7676;}
	.st683{fill:#FF88A4;}
	.st684{fill:#FF9852;}
	.st685{fill:url(#XMLID_2566_);}
	.st686{fill:url(#XMLID_2581_);}
	.st687{fill:#FFAF50;}
	.st688{fill:#FFB236;}
	.st689{fill:#FFBC73;}
	.st690{fill:#FFC555;}
	.st691{fill:none;stroke:url(#XMLID_7719_);stroke-width:3;stroke-miterlimit:10;}
	.st692{fill:none;stroke:url(#XMLID_2360_);stroke-width:6;stroke-miterlimit:10;}
	.st693{fill:#FFD366;}
	.st694{fill:#FFD773;}
	.st695{fill:#FFD77E;}
	.st696{fill:#FFDB92;}
	.st697{fill:#FFE2CA;}
	.st698{fill:#FFE52C;}
	.st699{fill:#FFE825;}
	.st700{fill:#FFEFAB;}
	.st701{fill:#FFFF00;}
	.st702{fill:#FFFFFF;}
	.st703{fill:url(#XMLID_2639_);}
	.st704{fill:url(#XMLID_2645_);}
	.st705{fill:url(#XMLID_2646_);}
	.st706{fill:url(#XMLID_2664_);}
	.st707{fill:url(#XMLID_2677_);}
	.st708{fill:url(#XMLID_2678_);}
	.st709{fill:none;stroke:url(#XMLID_2363_);stroke-width:6;stroke-miterlimit:10;}
	.st710{fill:url(#XMLID_2684_);}
	.st711{opacity:0.27;fill:#605C60;}
	.st712{fill:url(#XMLID_7550_);stroke:#383838;stroke-miterlimit:10;}
	.st713{fill:none;stroke:url(#XMLID_3435_);stroke-width:6;stroke-miterlimit:10;}
	.st714{fill:url(#XMLID_2862_);}
	.st715{fill:url(#XMLID_2875_);}
	.st716{fill:url(#XMLID_2884_);}
	.st717{fill:url(#XMLID_2885_);}
	.st718{fill:url(#XMLID_2886_);}
	.st719{fill:none;}
	.st720{fill:none;stroke:url(#XMLID_7680_);stroke-width:3;stroke-miterlimit:10;}
	.st721{fill:url(#XMLID_2904_);}
	.st722{fill:#FFFFFF;stroke:#1D1D1B;stroke-miterlimit:10;}
	.st723{fill:none;stroke:url(#XMLID_7516_);stroke-width:3;stroke-miterlimit:10;}
	.st724{fill:#666461;}
	.st725{fill:#666666;}
	.st726{fill:#9A5F3E;}
	.st727{fill:#9AF2F7;}
	.st728{fill:#FFFFFF;stroke:url(#XMLID_7561_);stroke-width:3;stroke-miterlimit:10;}
	.st729{fill:#9B9B9B;}
	.st730{fill:#CACCC8;}
	.st731{fill:#9BC16B;}
	.st732{fill:#FFFFFF;stroke:url(#XMLID_7565_);stroke-width:3;stroke-miterlimit:10;}
	.st733{fill:#686868;}
	.st734{fill:#68696D;}
	.st735{fill:#FFFFFF;stroke:url(#XMLID_7568_);stroke-width:3;stroke-miterlimit:10;}
	.st736{fill:#9CA09D;}
	.st737{fill:#CCA885;}
	.st738{fill:#CCCCCC;}
	.st739{fill:#CCD8E2;}
	.st740{fill:#9E7F66;}
	.st741{fill:#FFFFFF;stroke:url(#XMLID_7311_);stroke-width:0.25;stroke-miterlimit:10;}
	.st742{fill:#303233;}
	.st743{fill:#303844;}
	.st744{fill:none;stroke:url(#XMLID_4007_);stroke-width:4;stroke-miterlimit:10;}
	.st745{fill:#CECECE;}
	.st746{fill:#9FF4F4;}
	.st747{fill:#FFFFFF;stroke:url(#XMLID_7305_);stroke-width:0.25;stroke-miterlimit:10;}
	.st748{fill:#32ADF0;}
	.st749{fill:#333333;}
	.st750{opacity:0.24;fill:#FFFFFF;}
	.st751{fill:#FFFFFF;stroke:#CCCCCC;stroke-miterlimit:10;}
	.st752{fill:#FFFFFF;stroke:url(#XMLID_7297_);stroke-width:0.25;stroke-miterlimit:10;}
	.st753{opacity:0.5;fill:#A1A1A1;}
	.st754{fill:#352B1B;}
	.st755{fill:none;stroke:#444444;stroke-miterlimit:10;}
	.st756{fill:#353535;}
	.st757{fill:#353638;}
	.st758{fill:#3574DC;}
	.st759{fill:#FFFFFF;stroke:url(#XMLID_7325_);stroke-width:0.25;stroke-miterlimit:10;}
	.st760{fill:#FFFFFF;stroke:url(#XMLID_7319_);stroke-width:0.25;stroke-miterlimit:10;}
	.st761{fill:url(#XMLID_7386_);stroke:#232323;stroke-miterlimit:10;}
	.st762{fill:#6B7284;}
	.st763{fill:url(#XMLID_6095_);}
	.st764{fill:url(#XMLID_6097_);}
	.st765{fill:url(#XMLID_6098_);}
	.st766{fill:url(#XMLID_6099_);}
	.st767{fill:#39466B;}
	.st768{fill:#397AC9;}
	.st769{fill:#6D6D6D;}
	.st770{fill:#FFFFFF;stroke:url(#XMLID_7505_);stroke-width:5;stroke-miterlimit:10;}
	.st771{fill:none;stroke:url(#XMLID_4779_);stroke-width:3;stroke-miterlimit:10;}
	.st772{fill:#001F77;}
	.st773{fill:#003449;}
	.st774{fill:#004263;}
	.st775{fill:#006384;}
	.st776{fill:#006937;}
	.st777{fill:#008FB6;}
	.st778{fill:#00B2CD;}
	.st779{fill:url(#XMLID_6492_);}
	.st780{fill:#020202;}
	.st781{fill:#D0D0D0;}
	.st782{fill:url(#XMLID_6504_);}
	.st783{fill:url(#XMLID_6505_);}
	.st784{fill:url(#XMLID_6515_);}
	.st785{fill:url(#XMLID_6521_);}
	.st786{fill:url(#XMLID_6532_);}
	.st787{fill:url(#XMLID_6533_);}
	.st788{fill:url(#XMLID_6538_);}
	.st789{fill:url(#XMLID_6542_);}
	.st790{fill:url(#XMLID_6544_);}
	.st791{fill:url(#XMLID_6550_);}
	.st792{fill:url(#XMLID_6551_);}
	.st793{fill:url(#XMLID_6554_);}
	.st794{fill:url(#XMLID_6555_);}
	.st795{fill:none;stroke:#2368D9;stroke-width:3;stroke-miterlimit:10;}
	.st796{opacity:0.3;fill:#1D1D1B;}
	.st797{fill:#D1D1D1;}
	.st798{fill:none;stroke:url(#XMLID_7447_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st799{fill:#D29472;}
	.st800{fill:#042AB2;}
	.st801{fill:url(#XMLID_4056_);stroke:#232323;stroke-miterlimit:10;}
	.st802{opacity:0.19;fill:#998365;}
	.st803{fill:none;stroke:url(#XMLID_2390_);stroke-width:6;stroke-miterlimit:10;}
	.st804{fill:none;stroke:#E50A0A;stroke-width:2;stroke-miterlimit:10;}
	.st805{fill:#3A2914;}
	.st806{fill:#3A3A3A;}
	.st807{fill:#3A4747;}
	.st808{font-size:23;}
	.st809{font-size:31;}
	.st810{fill:url(#XMLID_241_);}
	.st811{fill:url(#XMLID_243_);}
	.st812{fill:url(#XMLID_244_);}
	.st813{fill:url(#XMLID_246_);}
	.st814{fill:url(#XMLID_251_);}
	.st815{fill:url(#XMLID_252_);}
	.st816{fill:none;stroke:url(#XMLID_4615_);stroke-width:3;stroke-miterlimit:10;}
	.st817{fill:none;stroke:url(#XMLID_4616_);stroke-width:3;stroke-miterlimit:10;}
	.st818{fill:none;stroke:url(#XMLID_7588_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st819{fill:#D6D6D6;}
	.st820{fill:none;stroke:url(#XMLID_7639_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st821{fill:#3D3D3D;}
	.st822{clip-path:url(#XMLID_2293_);}
	.st823{fill:url(#XMLID_3275_);}
	.st824{fill:url(#XMLID_3278_);}
	.st825{fill:url(#XMLID_3279_);}
	.st826{fill:url(#XMLID_3280_);}
	.st827{fill:url(#XMLID_3281_);}
	.st828{fill:url(#XMLID_3282_);}
	.st829{fill:url(#XMLID_3283_);}
	.st830{fill:none;stroke:url(#XMLID_7408_);stroke-width:4;stroke-miterlimit:10;}
	.st831{fill:#FFFFFF;stroke:url(#XMLID_7591_);stroke-width:3;stroke-miterlimit:10;}
	.st832{fill:none;stroke:url(#XMLID_7409_);stroke-width:4;stroke-miterlimit:10;}
	.st833{fill:#FFFFFF;stroke:url(#XMLID_7592_);stroke-width:3;stroke-miterlimit:10;}
	.st834{opacity:0.37;fill:url(#XMLID_3466_);}
	.st835{opacity:0.37;fill:url(#XMLID_3469_);}
	.st836{clip-path:url(#XMLID_2344_);}
	.st837{fill:url(#XMLID_3333_);}
	.st838{fill:url(#XMLID_3334_);}
	.st839{clip-path:url(#XMLID_2362_);}
	.st840{clip-path:url(#XMLID_2364_);}
	.st841{clip-path:url(#XMLID_2366_);}
	.st842{fill:url(#XMLID_3344_);}
	.st843{fill:url(#XMLID_3345_);}
	.st844{fill:#707070;}
	.st845{fill:url(#XMLID_3400_);}
	.st846{fill:url(#XMLID_3401_);}
	.st847{fill:url(#XMLID_3402_);}
	.st848{fill:url(#XMLID_3441_);}
	.st849{fill:url(#XMLID_3452_);}
	.st850{fill:url(#XMLID_3463_);}
	.st851{opacity:0.37;fill:url(#XMLID_3603_);}
	.st852{fill:#A0A0A0;}
	.st853{fill:none;stroke:url(#XMLID_4031_);stroke-width:4;stroke-miterlimit:10;}
	.st854{fill:url(#XMLID_7385_);stroke:#383838;stroke-miterlimit:10;}
	.st855{fill:#FFFFFF;stroke:url(#XMLID_7282_);stroke-width:0.25;stroke-miterlimit:10;}
	.st856{fill:url(#XMLID_7333_);stroke:#444444;stroke-miterlimit:10;}
	.st857{fill:#727272;}
	.st858{fill:none;stroke:url(#XMLID_7673_);stroke-width:6;stroke-miterlimit:10;}
	.st859{fill:url(#XMLID_3613_);}
	.st860{fill:url(#XMLID_3617_);}
	.st861{fill:url(#XMLID_3618_);}
	.st862{fill:url(#XMLID_3619_);}
	.st863{fill:url(#XMLID_3624_);}
	.st864{fill:url(#XMLID_3625_);}
	.st865{fill:url(#XMLID_3626_);}
	.st866{fill:url(#XMLID_3627_);}
	.st867{fill:url(#XMLID_3628_);}
	.st868{fill:url(#XMLID_3629_);}
	.st869{fill:url(#XMLID_7335_);stroke:#444444;stroke-miterlimit:10;}
	.st870{fill:url(#XMLID_7336_);stroke:#444444;stroke-miterlimit:10;}
	.st871{fill:url(#XMLID_7337_);stroke:#444444;stroke-miterlimit:10;}
	.st872{fill:none;stroke:url(#XMLID_7374_);stroke-width:4;stroke-miterlimit:10;}
	.st873{fill:url(#XMLID_7338_);stroke:#444444;stroke-miterlimit:10;}
	.st874{fill:#A2A599;}
	.st875{fill:#A2A7AC;}
	.st876{fill:#FFFFFF;stroke:url(#XMLID_7276_);stroke-width:0.25;stroke-miterlimit:10;}
	.st877{fill:#FFFFFF;stroke:url(#XMLID_7310_);stroke-width:0.25;stroke-miterlimit:10;}
	.st878{fill:#A3A3A3;}
	.st879{fill:url(#XMLID_3818_);}
	.st880{fill:url(#XMLID_3819_);}
	.st881{fill:url(#XMLID_3820_);}
	.st882{fill:url(#XMLID_3821_);}
	.st883{fill:url(#XMLID_3822_);}
	.st884{fill:url(#XMLID_3823_);}
	.st885{fill:url(#XMLID_3824_);}
	.st886{fill:url(#XMLID_3825_);}
	.st887{fill:url(#XMLID_3826_);}
	.st888{fill:url(#XMLID_3827_);}
	.st889{fill:url(#XMLID_3830_);}
	.st890{fill:url(#XMLID_3832_);}
	.st891{fill:url(#XMLID_3833_);}
	.st892{fill:url(#XMLID_3834_);}
	.st893{fill:url(#XMLID_3835_);}
	.st894{fill:url(#XMLID_3836_);}
	.st895{fill:none;stroke:#28F7D1;stroke-miterlimit:10;}
	.st896{fill:#A4704C;}
	.st897{fill:#A4BCC1;}
	.st898{fill:#0A2D56;}
	.st899{fill:#FFFFFF;stroke:url(#XMLID_7286_);stroke-width:0.25;stroke-miterlimit:10;}
	.st900{fill:none;stroke:url(#XMLID_4777_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st901{fill:#A57B44;}
	.st902{fill:url(#XMLID_4481_);stroke:#232323;stroke-miterlimit:10;}
	.st903{fill:none;stroke:url(#XMLID_7558_);stroke-width:3;stroke-miterlimit:10;}
	.st904{fill:#777777;}
	.st905{fill:none;stroke:url(#XMLID_7419_);stroke-width:4;stroke-miterlimit:10;}
	.st906{fill:#DA9571;}
	.st907{fill:#0C455B;}
	.st908{fill:#FFFFFF;stroke:url(#XMLID_7314_);stroke-width:0.25;stroke-miterlimit:10;}
	.st909{fill:none;stroke:url(#XMLID_2321_);stroke-width:3;stroke-miterlimit:10;}
	.st910{fill:#DB6812;}
	.st911{fill:#0D1F30;}
	.st912{fill:#A8947E;}
	.st913{fill:#FFFFFF;stroke:url(#XMLID_7308_);stroke-width:0.25;stroke-miterlimit:10;}
	.st914{fill:#A8A8A8;}
	.st915{fill:url(#XMLID_4055_);stroke:#383838;stroke-miterlimit:10;}
	.st916{fill:url(#XMLID_7392_);stroke:#383838;stroke-miterlimit:10;}
	.st917{fill:url(#XMLID_7393_);stroke:#383838;stroke-miterlimit:10;}
	.st918{fill:#79E0E0;}
	.st919{fill:#DCFFF8;}
	.st920{fill:url(#XMLID_7342_);stroke:#444444;stroke-miterlimit:10;}
	.st921{fill:url(#XMLID_7343_);stroke:#444444;stroke-miterlimit:10;}
	.st922{fill:url(#XMLID_7344_);stroke:#444444;stroke-miterlimit:10;}
	.st923{fill:#0F0F0F;}
	.st924{fill:#0F4B63;}
	.st925{fill:#DDDDDD;}
	.st926{fill:#DDE5ED;}
	.st927{fill:url(#XMLID_7345_);stroke:#444444;stroke-miterlimit:10;}
	.st928{fill:#404949;}
	.st929{fill:url(#XMLID_7346_);stroke:#444444;stroke-miterlimit:10;}
	.st930{fill:#DEFFAE;}
	.st931{fill:none;stroke:url(#XMLID_7640_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st932{fill:#DFDFDF;}
	.st933{fill:#424242;}
	.st934{fill:url(#XMLID_7458_);stroke:#232323;stroke-miterlimit:10;}
	.st935{fill:none;stroke:url(#XMLID_7423_);stroke-width:4;stroke-miterlimit:10;}
	.st936{fill:none;stroke:url(#XMLID_7424_);stroke-width:4;stroke-miterlimit:10;}
	.st937{opacity:0.51;fill:#FFFFFF;enable-background:new    ;}
	.st938{fill:none;stroke:url(#XMLID_7425_);stroke-width:4;stroke-miterlimit:10;}
	.st939{fill:none;stroke:url(#XMLID_7426_);stroke-width:4;stroke-miterlimit:10;}
	.st940{fill:#444444;}
	.item-drag{
		margin:2px
	}
	.btn-comprobar{
	background: #E9F3F3; 
	color: rgb(38, 146, 192);
	padding: 10px 10px;
	border: solid 2px rgb(62, 144, 179);;
	}
	.retroalimentacion {
    width: 100%;
    //border: solid 2px;
    margin-top: 20px;
    text-align: center;
    p {
        margin: 0;
        padding: 0;
        font-family: FontBase-BoldItalic;
        display: flex;
        align-items: center;
        justify-content: start;
        .icono {
            margin-right: 0.5em;
		}
	}
	
}
.errorR{
  color:red;
  //background: red;
}
.bien{
  color:green;
  //background: greenyellow;
}
.EntradaTxt {
    border-bottom: 1px solid;
    width: 82px;    
    text-align: center;                                                                                                                                      
	font-size: 17px; 
	font-weight: bold;
}	
.opciones {
	p{ 
		font-size: 16px;
	}
}
td {
  border: #23cad9ff 1px solid;
  font-size: 13.6px;
  width: 50px;
}
</style>
